import React from 'react';
import { useTranslate } from 'react-redux-multilingual'

const ArticleVentilationForm = (props) => {
    const t = useTranslate();

    const handleChangeVentilationType = (e) => {
        props.setInitIsFinish(true)
        props.setVentilationArticleType(e.target.value)
    };

    return(<div className='row mb-2'>
        <div className='col-6'>
            <div className='form-group'>
                <label>{t('selectBreakdownField')}</label>
                <select disabled={props.loadingTypeConf} value={props.ventilationArticleType} className='form-control' onChange={(e)=>handleChangeVentilationType(e)}>
                    <option value="">-- Select --</option>
                    {props.ventilationArticleDatas.map(value=>{
                        return(
                            <option key={value.data} value={value.data}>{value.name}</option>
                        )
                    })}
                </select>
                {props.loadingTypeConf ? <div className="spinner-border spinner-border-sm" style={{position:'absolute', top:'55%'}}></div> : false}
            </div>
        </div>
        <div className="col-6">
            <div className="row d-flex align-items-center justify-content-between" style={{width:'100%'}}>
                <div className="form-group col-10">
                    <label>{t('AddNewBreakdownLine')}</label>
                    {!props.ventilationSelectDatas ? 
                        <input disabled={props.ventilationArticleType==''} value={props.ventilationFieldName} type="text" className="form-control" onChange={(e)=>props.setVentilationFieldName(e.target.value)}/>
                    :
                        <select disabled={props.ventilationArticleType==''} value={props.ventilationFieldName} className='form-control' onChange={(e)=>props.setVentilationFieldName(e.target.value)}>
                            <option value="">-- Select --</option>
                            {props.ventilationSelectDatas.map(item=>{
                                return(
                                    <option key={item} value={item}>{item}</option>
                                )
                            })}
                        </select>
                    }
                </div>
                <div className="col-2">
                    <button disabled={props.ventilationFieldName==''} className='btn btn-success' onClick={()=>props.addNewVentilationField(props.ventilationFieldName)}>{t('add')}</button>
                </div>
            </div>
        </div>
    </div>
    )
}

export default ArticleVentilationForm;